<app-page-heading [heading]="'Organisation scopes'"></app-page-heading>

<div class="stretch column align">
    

    <mat-card>
        <mat-card-header>
            <mat-card-title>
                <h3>{{userOrganization!.user.name}}</h3>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            
            <section *ngFor="let item of availableScopes" [formGroup]="business">
                <p>
                    <mat-checkbox color="primary">
                        {{item.name}}
                    </mat-checkbox>
                </p>
                
            </section>
            
        </mat-card-content>
    </mat-card>
</div>